const getHash = () =>
    Date.now().toString(36) + Math.random().toString(36).substring(2)
import api from '@/api/customer'
import { errorHandler } from '../exports/error_management'

const state = {
    item: null,
    customerId: null,
    items: [],
    items_all: [],
    pagination: null,
    customerUser: null,
    opportunity_status: [],
    opportunity_status_pagination: null,
    filters: {},
    query: '',
    crm_filters: null,
}

const getters = {
    customers(state) {
        return state.items || []
    },

    customers_all(state) {
        return state.items_all || []
    },

    customer(state) {
        return state.item || null
    },

    customerUsers(state) {
        const users = ((state.item || {}).users || []).map(x => ({...x.user, portal_access: x.portal_access}))
        console.log('users12', users)
        return users
    },

    customerPortalUsers(state) {
        const users = (state.item || {}).users || []
        console.log('users12', users)
        return users
    },
}

const mutations = {
    SET_CUSTOMER(state, payload) {
        state.item = payload
    },
    SET_CUSTOMER_ID(state, customerId) {
        state.customerId = customerId
    },
    SET_CUSTOMERS(state, payload) {
        state.items = payload
    },
    SET_CUSTOMERS_ALL(state, payload) {
        state.items_all = payload
    },
    SET_FILTERS(state, payload) {
        state.filters = payload
    },
    SET_QUERY(state, payload) {
        state.query = payload
    },
    DELETE_CUSTOMER(state, id) {
        let index = state.items.findIndex(x => x.id == id)
        state.items.splice(index, 1)
        console.log('deleted item at index ' + index)
    },
    set_pagination(state, pag) {
        state.pagination = pag
    },

    SET_CRM_OPPORTUNITY_STATUS(state, payload) {
        state.opportunity_status = payload
    },

    SET_CRM_OPPORTUNITY_STATUS_PAGINATION(state, payload) {
        state.opportunity_status_pagination = payload
    },

    SET_CRM_FILTERS(state, filters) {
        state.crm_filters = filters;
    },
}

const actions = {
    async create(context, payload) {
        try {
            const res = await api.create(payload) //.then(() => {})
            console.log('customer create', res.data.success.data)
            context.commit('SET_CUSTOMER', res.data.success.data)
            context.commit('SET_CUSTOMER_ID', res.data.success.data.id)
            return res.data.success.data
        } catch (err) {
            errorHandler(err)
        }
    },


    async createCustomerModel(context, payload) {
        try {
            const res = await api.createCustomerModel(payload) //.then(() => {})
            console.log('customer create', res.data.success.data)
            context.commit('SET_CUSTOMER', res.data.success.data)
            context.commit('SET_CUSTOMER_ID', res.data.success.data.id)
            return res.data.success.data
        } catch (err) {
            errorHandler(err)
        }
    },

    async uploadCustomer({ commit, state }, payload) {
        try {
            const result = await api.upload(payload)

            /*   .then(response => response)
            .catch(error => error.response) */

            let success = result.data.success
            let { data } = success == undefined ? {} : success
            if (!data) return result.data.success || result.data.error

            const customers = [...state.items]
            const idx = customers.findIndex(x => x.id === data.id)
            customers.splice(idx === -1 ? customers.length : idx, 1, data)
            commit('SET_CUSTOMERS', customers)
            ///return result.data.success
        } catch (err) {
            errorHandler(err)
        }
    },

    fetch(context, params) {
        console.log('fetching customers', params)
        let { query, page: pg, filters } = params || {}
        query = query || ''
        pg = pg || 1
        return api
            .fetch(query, pg, filters)
            .then(result => {
                let {
                    data,
                    current_page: page,
                    per_page: pageSize,
                    total,
                } = result.data.success.data
                console.log('customers search---', data)
                context.commit('SET_CUSTOMERS', data)
                context.commit('SET_FILTERS', filters)
                context.commit('SET_QUERY', query)
                context.commit('set_pagination', {
                    page,
                    pageSize,
                    total,
                })
            })
            .catch(err => {
                errorHandler(err)
            })
    },
    fetchById(context, id) {
        return api
            .fetchById(id)
            .then(
                ({
                    data: {
                        success: { data: item },
                    },
                }) => {
                    console.log('assumed customer', item)
                    context.commit('SET_CUSTOMER', item)
                }
            )
            .catch(err => {
                errorHandler(err)
            })
    },

    fetchAll(context) {
        return api
            .fetchAll()
            .then(
                ({
                    data: {
                        success: { data },
                    },
                }) => {
                    console.log('assumed customer', data)
                    context.commit('SET_CUSTOMERS_ALL', data)
                }
            )
            .catch(err => {
                errorHandler(err)
            })
    },

    async fetchByIdFunction(_, id) {
        try {
            const {
                data: {
                    success: { data },
                },
            } = await api.fetchById(id);
            return data;
        } catch (err) {
            errorHandler(err)
        }
    },

    update(context, payload) {
        return api
            .update(payload.id, payload)
            .then(() => { })
            .catch(err => {
                errorHandler(err)
            })
    },
    delete(context, id) {
        console.log('deleting')
        return api
            .delete(id)
            .then(() => {
                context.commit('DELETE_CUSTOMER', id)
            })
            .catch(err => {
                errorHandler(err)
            })
    },
    //////////////////////////////////////customer users//////////////////
    async createUser(context, { customer_id, data }) {
        try {
            console.log('customer create---', { customer_id, data })
            await api.createUser(customer_id, data)
            await context.dispatch('fetchById', customer_id)
        } catch (err) {
            errorHandler(err)
        }
    },
    clear({ commit }) {
        commit('SET_CUSTOMERS', [])
    },
    merge({ state, commit }, item) {
        item.data.hash = item.data.hash || getHash()
        const items = [...state.items]
        let index = items.findIndex(x => x.hash == item.data.hash)
        if (index >= 0) items.splice(index, 1, item.data)
        else items.push(item.data)
        commit('SET_CUSTOMERS', items)
        // commit('SET_ITEMS', items)
    },
    deleteContact({ state, commit }, hash) {
        const customers = [...state.items]
        const index = customers.findIndex(x => x.hash == hash)
        customers.splice(index, 1)
        commit('SET_CUSTOMERS', customers)
    },

    async createContact(context, payload) {
        console.log('customerData', payload)
        try {
            await api.createContact(payload)
        } catch (err) {
            errorHandler(err)
        }
    },

    async updateUser(context, { customer_id, data }) {
        try {
            const userData = { ...data }
            const user_id = data.id
            delete userData.id
            await api.updateUser(customer_id, user_id, userData)
            await context.dispatch('fetchById', customer_id)
        } catch (err) {
            errorHandler(err)
        }
    },
    async deleteUser(context, { customer_id, user_id }) {
        try {
            await api.deleteUser(customer_id, user_id)
            await context.dispatch('fetchById', customer_id)
        } catch (err) {
            errorHandler(err)
        }
    },

    async fetchAllCrmOpportunityStatus(context, params) {
        try {

            let { query, page: pg, filters } = params || {}
            query = query || ''
            pg = pg || 1
            const results = await api.fetchAllCrmOpportunityStatus(query, pg, filters)
            let {
                data,
                current_page: page,
                per_page: pageSize,
                total,
            } = results.data.success.data
            console.log('customers search---', data)
            context.commit('SET_CRM_OPPORTUNITY_STATUS', data)
            context.commit('SET_CRM_FILTERS', filters)
            context.commit('SET_CRM_OPPORTUNITY_STATUS_PAGINATION', {
                page,
                pageSize,
                total,
            })
        } catch (err) {
            errorHandler(err)
        }
    },

    async fetchAllCrmOpportunityStatusExcel(context, { query, filters }) {
        try {
            filters = filters || {};
            query = query || "";
            context.commit('SET_CRM_FILTERS', filters);
            const response = await api.fetchAllCrmOpportunityStatusExcel(query, filters, true);
            // const blob = new Blob([response.data], {
            //     type:
            //         "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            // });
            // const url = window.URL.createObjectURL(blob);
            // const link = document.createElement("a");
            // link.href = url;
            // link.setAttribute("download", "OppertunityStatus.xlsx");
            // document.body.appendChild(link);
            // link.click();
            // document.body.removeChild(link);
            // window.URL.revokeObjectURL(url);
            const base64Data = response.data.file_data.trim();

            // Decode the Base64 string
            const binaryString = window.atob(base64Data);
            const len = binaryString.length;
            const bytes = new Uint8Array(len);

            for (let i = 0; i < len; i++) {
                bytes[i] = binaryString.charCodeAt(i);
            }

            const blob = new Blob([bytes.buffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", response.data.file_name);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (err) {
            console.error("Error fetching request:", err);
        }
    },
    async fetchAllCrmOpportunityStatusDashboard(context, { query, filters }) {
        try {
            filters = filters || {};
            query = query || "";
            context.commit('SET_CRM_FILTERS', filters);
            const response = await api.fetchAllCrmOpportunityStatusDashboard(query, filters, true);
            // const blob = new Blob([response.data], {
            //     type:
            //         "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            // });
            // const url = window.URL.createObjectURL(blob);
            // const link = document.createElement("a");
            // link.href = url;
            // link.setAttribute("download", "OppertunityStatus.xlsx");
            // document.body.appendChild(link);
            // link.click();
            // document.body.removeChild(link);
            // window.URL.revokeObjectURL(url);
            const base64Data = response.data.file_data.trim();

            // Decode the Base64 string
            const binaryString = window.atob(base64Data);
            const len = binaryString.length;
            const bytes = new Uint8Array(len);

            for (let i = 0; i < len; i++) {
                bytes[i] = binaryString.charCodeAt(i);
            }

            const blob = new Blob([bytes.buffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", response.data.file_name);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (err) {
            console.error("Error fetching request:", err);
        }
    },

    set_crm_filter(context, payload) {
        context.commit('SET_CRM_FILTERS', payload)
    },
    async exportExcel(context, { filters_c, query_c }) {
        try {
            filters_c = filters_c || {};
            query_c = query_c || '';

            const response = await api.exportExcel(query_c, filters_c);
            // const blob = new Blob([response.data], {
            //     type:
            //         "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            // });
            // const url = window.URL.createObjectURL(blob);
            // const link = document.createElement("a");
            // link.href = url;
            // link.setAttribute("download", "customers.csv");
            // document.body.appendChild(link);
            // link.click();
            // document.body.removeChild(link);
            // window.URL.revokeObjectURL(url);
            const base64Data = response.data.file_data.trim();

            // Decode the Base64 string
            const binaryString = window.atob(base64Data);
            const len = binaryString.length;
            const bytes = new Uint8Array(len);

            for (let i = 0; i < len; i++) {
                bytes[i] = binaryString.charCodeAt(i);
            }

            const blob = new Blob([bytes.buffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", response.data.file_name);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (err) {
            console.error("Error fetching request:", err);
        }
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
